import { Button } from '@lt/components';
import { useTranslation } from '@lt/localization';
import PropTypes from 'prop-types';
import React from 'react';
import { ButtonWithLoader } from 'src/components/AuthNew/components/ButtonWithLoader/ButtonWithLoader';
import styled, { css } from 'styled-components';
import AgreeBlock from '../../../components/AgreeBlock';
import { formatCurrency } from '../../../utils/stringUtils';
import PaymentCardContainer from '../containers/PaymentCardContainer';
import withMobile from '../hocs/withMobile';
import Agreement from './Agreement';

const PaymentBlock = ({
  isMobile,
  isCardValid,
  paymentAmount,
  onGoBack,
  onSubmit,
  isCreated,
  isLoading,
}) => {
  const { t } = useTranslation();
  return (
    <StyledContainer>
      <StyledPaymentCard />
      <AgreeBlock>
        <Agreement />
      </AgreeBlock>
      <ButtonGroup isMobile={isMobile}>
        <StyledSubmitButton
          size="large"
          isLoading={isLoading}
          disabled={!(isCardValid && paymentAmount)}
          onClick={onSubmit}
          width="100%"
        >
          {paymentAmount
            ? `${t('commonPages.certificate.pay')} ${formatCurrency(
                paymentAmount,
              )}`
            : t('commonPages.certificate.inputAmount')}
        </StyledSubmitButton>
        <StyledBackButton onClick={onGoBack} disabled={isCreated}>
          {t('commonPages.certificate.back')}
        </StyledBackButton>
      </ButtonGroup>
    </StyledContainer>
  );
};

const StyledPaymentCard = styled(PaymentCardContainer)`
  margin-bottom: 15px;
  box-shadow: 0 10px 20px 0 rgba(201, 190, 187, 0.3),
    inset 0 -1px 0 0 rgba(0, 0, 0, 0.1);
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
`;

const StyledSubmitButton = styled(ButtonWithLoader).attrs({ primary: true })`
  min-width: 200px;
  margin-top: 0;
  padding-right: 20px;
  padding-left: 20px;
  font-size: 14px;
`;
const StyledBackButton = styled(Button).attrs({ functional: true })`
  color: ${({ theme }) => theme.colors.greyLight};
`;

const ButtonGroup = styled.div`
  margin-top: 20px;
  margin-bottom: 15px;
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;

  ${(props) =>
    props.isMobile
      ? css`
          margin-top: 10px;
          margin-bottom: 5px;
          flex-direction: column;
          justify-content: center;

          ${StyledSubmitButton} {
            margin-bottom: 15px;
            width: 100%;
          }
        `
      : css`
          ${StyledSubmitButton} {
            margin-right: 30px;
            width: auto;
          }
        `};
`;

PaymentBlock.propTypes = {
  isMobile: PropTypes.bool,
  isCardValid: PropTypes.bool.isRequired,
  onGoBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  paymentAmount: PropTypes.number.isRequired,
  isCreated: PropTypes.bool.isRequired,
};
PaymentBlock.defaultProps = {
  isMobile: false,
};

export default withMobile(PaymentBlock);
